import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const QuestionsTutorialModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=XDcOpCFD5Jg" />
);

export default QuestionsTutorialModal;
